import { DataAttributeDefinitions } from 'scrivito'

import { pisaTicketDataClass } from './Pisa/pisaTicketDataClass'

const attributes: DataAttributeDefinitions = {}

export const Ticket = pisaTicketDataClass(attributes)
